// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(el) {
};

BCSfFilter.prototype.buildSuggestionProductPrice = function(a) {
    a.price_min *= 100,
    a.price_max *= 100,
    a.compare_at_price_min *= 100,
    a.compare_at_price_max *= 100;
  
  // lowest price based on availability
  var $x_comp_price = [], 
      $x_price = [],
      $x_price_min = [], 
      $x_price_max = [];
  for (var i = 0; i < a['variants'].length; i++) {
    var current_variant = a['variants'][i];
    if (current_variant.available) {
      $x_comp_price.push(current_variant.compare_at_price);
      $x_price.push(current_variant.price);
    }
  }
  $x_price_max = (Math.max.apply(null,$x_comp_price)).toFixed(2);
  $x_price_min = (Math.min.apply(null,$x_price)).toFixed(2);
  console.log($x_price_min);
  console.log($x_price_max);
  var priceVaries = $x_price_min != $x_price_max; // Check a product has many prices
  console.log(priceVaries);
  
  
  
  
  
  
    var b = a.compare_at_price_min > a.price_min
      , c = this.formatMoney(a.price_min)
      , d = this.formatMoney(a.compare_at_price_min);
    this.getSettingValue("search.removePriceDecimal") && (c = this.removeDecimal(c),
    d = this.removeDecimal(d));
    var e = "";
  	var dstring = d.toString().replace("₱","").replace(",","");
    var g = (dstring !== $x_price_min) ? "<s>" + d + "</s>  " : "";
    return this.getSettingValue("search.showSuggestionProductPrice") && (e += '<div class="' + this.class.searchSuggestion + '-product-price">',
    b && this.getSettingValue("search.showSuggestionProductSalePrice") ? (e += g,
    e += '<span class="bc-sf-product-sale-price">' + $x_price_min + "</span>") : e += '<span class="bc-sf-product-regular-price">' + $x_price_max + "</span>",
    e += "</div>"),
    e
}